export const iconFontAwesomeShoppingCcAmex = (
	<i className="fa-solid fa-cc-amex"></i>
);
